import * as Animate from "react-reveal";
import Avatar from "../../../assets/images/png/avatars/2.webp";

const CareerStorySection = () => {
  return (
    <section className="bg-white pb-16 md:pb-20 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div
            className="rounded-2xl p-7 md:p-10 flex flex-wrap items-center gap-8"
            style={{ background: "#fdf2df" }}
          >
            <div className="relative w-24 h-24 flex-none">
              <img
                src={Avatar}
                alt="Eromonsele Gloria"
                className="w-24 h-24 rounded-full object-cover"
              />
              <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 whitespace-nowrap bg-secondary text-primary text-[10px] font-poppins font-extrabold px-2.5 py-1 rounded-full">
                FROM DAY ONE
              </span>
            </div>

            <div className="flex-1 min-w-[240px]">
              <p className="text-[#8e5e00] font-poppins text-xs font-extrabold tracking-widest uppercase mb-2">
                The people behind the work
              </p>
              <h3 className="font-poppins font-extrabold text-2xl text-primary mb-3">
                &ldquo;The future we are building matters to me.&rdquo;
              </h3>
              <p className="text-gray font-poppins text-sm leading-relaxed mb-3">
                Gloria has been part of Utiva from the beginning. For her, the
                work is about helping build a new kind of learning company while
                creating a meaningful future of her own.
              </p>
              <p className="font-poppins text-sm">
                <strong className="text-default font-extrabold">
                  Eromonsele Gloria
                </strong>{" "}
                <span className="text-gray">Utiva Growth Lead</span>
              </p>
            </div>

            <a
              href="/stories"
              className="flex-none bg-white text-primary font-poppins font-extrabold rounded-xl inline-flex items-center gap-2 px-5 py-4 whitespace-nowrap custom-btn"
            >
              See more team stories →
            </a>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default CareerStorySection;
